import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CloudFeatureFlagsService, FEATURE_FLAG_SERVICE } from '@shure/cloud/shared/utils/feature-flags';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

@Injectable()
export class SdcSupportService {
	constructor(@Inject(FEATURE_FLAG_SERVICE) private readonly featureFlagsService: CloudFeatureFlagsService) {}

	public supportsSdc$(model: DeviceModel): Observable<boolean> {
		return this.featureFlagsService.getDynamicConfig('cdm-app-config').pipe(
			map((config) => {
				return config.data?.sdc?.[model]?.enabled ?? true;
			})
		);
	}
}
